module.exports = __webpack_public_path__ + "c4a2e49ffb6e0dc37c7e4f372b634eb8.svg";